module.exports = __webpack_public_path__ + "img/favpng_cartoon-clip-art.0417b888.png";